import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './react/jobs-filter/app'

import { __ } from '@wordpress/i18n';

try {
    ReactDOM
        .createRoot(document.getElementById('advanced-jobs-search'))
        .render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        )
} catch (e) {

    // keeping this to trigger the translation from the main file
    console
        .table(__('Root element error', 'job'), e)
}
